import React from 'react';
import { ButtonProps } from 'antd/es/button';
import { FormInstance } from 'antd/es/form';

import * as S from './styles';

type Props = ButtonProps & {
  formInstance?: FormInstance;
  customColor?: S.ButtonColorOptions;
};

const Button = React.forwardRef<HTMLButtonElement, React.PropsWithChildren<Props>>(
  ({ children, loading, formInstance, disabled, customColor, ...buttonProps }, ref) => {
    return (
      <S.Button
        ref={ref}
        loading={loading}
        htmlType="submit"
        $customColor={customColor}
        {...buttonProps}
        disabled={
          disabled ||
          !!loading ||
          formInstance?.getFieldsError().some((field) => field.errors.length > 0)
        }
      >
        {children}
      </S.Button>
    );
  }
);

export default Button;
